function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListActions(props) {
  const {
    listActions = [],
    isLoading = false
  } = props;
  const {
    isMobile
  } = useIsMobile();
  const listActionsClasses = classNames({
    [moduleStyles['sib-list__actions']]: true,
    [moduleStyles['sib-list__actions-xs']]: isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: listActionsClasses
  }, isLoading ? '' : listActions?.map((item, i) => {
    return /*#__PURE__*/React.createElement(Button, _extends({}, item, {
      key: i
    }));
  }));
}
ListActions.propTypes = {
  listActions: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool
};
export default ListActions;